module.exports = __webpack_public_path__ + "9fcecc60bf4b150f26643a581929b7cf.jpg";